<mat-card>
    <mat-card-header>
        <mat-card-title>Lista aziende</mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <table [style.display]="isDetailsHidden()">
      <tr>
        <td align="left">
            <span style="font-family:Roboto; font-weight: bold; font-size: 18px;">Informazioni aggiuntive: {{azienda.Nome}}</span>
        </td>
      </tr>
    </table>

        <table mat-table [style.display]="isDetailsHidden()" [dataSource]="dataSource2" class="mat-elevation-z8">
          <ng-container matColumnDef="Attributo">
              <th mat-header-cell *matHeaderCellDef>Attributo</th>
              <td mat-cell *matCellDef="let azienda"> {{azienda.Attributo}} </td>
          </ng-container>

          <ng-container matColumnDef="Valore">
              <th mat-header-cell *matHeaderCellDef>Valore</th>
              <td mat-cell *matCellDef="let azienda"> {{azienda.Valore}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
        </table>

        <br>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="sel">
        <th mat-header-cell *matHeaderCellDef>Altro</th>
        <td mat-cell *matCellDef="let azienda">
          <mat-checkbox
            (click)="manageCheckboxclick($event, azienda)"
            (change)="$event ? selection.toggle(azienda) : null"
            [checked]="selection.isSelected(azienda)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="Nome">
          <th [style.display]="getConfigurazione().Nome" mat-header-cell *matHeaderCellDef> Nome
            <img src="./assets/images/sort.png" (click)="manageClick('Nome')"/>
          </th>
          <td [style.display]="getConfigurazione().Nome" mat-cell *matCellDef="let azienda"> {{azienda.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Partitaiva">
          <th [style.display]="getConfigurazione().Partitaiva" mat-header-cell *matHeaderCellDef> Partita IVA
            <img src="./assets/images/sort.png" (click)="manageClick('Partitaiva')"/>
          </th>
          <td [style.display]="getConfigurazione().Partitaiva" mat-cell *matCellDef="let azienda"> {{azienda.Partitaiva}} </td>
      </ng-container>

      <ng-container matColumnDef="Missione">
          <th [style.display]="getConfigurazione().Missione" mat-header-cell *matHeaderCellDef> Missione
            <img src="./assets/images/sort.png" (click)="manageClick('Missione')"/>
          </th>
          <td [style.display]="getConfigurazione().Missione" mat-cell *matCellDef="let azienda"> {{azienda.Missione}} </td>
      </ng-container>

      <ng-container matColumnDef="Codicefiscale">
          <th [style.display]="getConfigurazione().Codicefiscale" mat-header-cell *matHeaderCellDef> Codice fiscale
            <img src="./assets/images/sort.png" (click)="manageClick('Codicefiscale')"/>
          </th>
          <td [style.display]="getConfigurazione().Codicefiscale" mat-cell *matCellDef="let azienda"> {{azienda.Codicefiscale}} </td>
      </ng-container>

      <ng-container matColumnDef="Email">
          <th [style.display]="getConfigurazione().Email" mat-header-cell *matHeaderCellDef> email
            <img src="./assets/images/sort.png" (click)="manageClick('Email')"/>
          </th>
          <td [style.display]="getConfigurazione().Email" mat-cell *matCellDef="let azienda"> {{azienda.Email}} </td>
      </ng-container>

      <ng-container matColumnDef="Pec">
          <th [style.display]="getConfigurazione().Pec" mat-header-cell *matHeaderCellDef> PEC
            <img src="./assets/images/sort.png" (click)="manageClick('Pec')"/>
          </th>
          <td [style.display]="getConfigurazione().Pec" mat-cell *matCellDef="let azienda"> {{azienda.Pec}} </td>
      </ng-container>

      <ng-container matColumnDef="Telefono">
          <th [style.display]="getConfigurazione().Telefono" mat-header-cell *matHeaderCellDef> Telefono
            <img src="./assets/images/sort.png" (click)="manageClick('Telefono')"/>
          </th>
          <td [style.display]="getConfigurazione().Telefono" mat-cell *matCellDef="let azienda"> {{azienda.Telefono}} </td>
      </ng-container>

      <ng-container matColumnDef="Cellulare">
          <th [style.display]="getConfigurazione().Cellulare" mat-header-cell *matHeaderCellDef> Cellulare
            <img src="./assets/images/sort.png" (click)="manageClick('Cellulare')"/>
          </th>
          <td [style.display]="getConfigurazione().Cellulare" mat-cell *matCellDef="let azienda"> {{azienda.Cellulare}} </td>
      </ng-container>

      <ng-container matColumnDef="Svi">
          <th [style.display]="getConfigurazione().Svi" mat-header-cell *matHeaderCellDef> Svi
            <img src="./assets/images/sort.png" (click)="manageClick('Cellulare')"/>
          </th>
          <td [style.display]="getConfigurazione().Svi" mat-cell *matCellDef="let azienda"> {{azienda.Svi}} </td>
      </ng-container>

      <ng-container matColumnDef="Ragionesociale">
          <th [style.display]="getConfigurazione().Ragionesociale" mat-header-cell *matHeaderCellDef> Ragione sociale
            <img src="./assets/images/sort.png" (click)="manageClick('Ragionesociale')"/>
          </th>
          <td [style.display]="getConfigurazione().Ragionesociale" mat-cell *matCellDef="let azienda"> {{azienda.Ragionesociale}} </td>
      </ng-container>

      <ng-container matColumnDef="Attivita">
          <th [style.display]="getConfigurazione().Attivita" mat-header-cell *matHeaderCellDef> Attività
            <img src="./assets/images/sort.png" (click)="manageClick('Attivita')"/>
          </th>
          <td [style.display]="getConfigurazione().Attivita" mat-cell *matCellDef="let azienda"> {{azienda.Attivita}} </td>
      </ng-container>

      <ng-container matColumnDef="Numerodipendenti">
          <th [style.display]="getConfigurazione().Numerodipendenti" mat-header-cell *matHeaderCellDef> Numero dipendenti
            <img src="./assets/images/sort.png" (click)="manageClick('Numerodipendenti')"/>
          </th>
          <td [style.display]="getConfigurazione().Numerodipendenti" mat-cell *matCellDef="let azienda"> {{azienda.Numerodipendenti}} </td>
      </ng-container>

      <ng-container matColumnDef="Rea">
          <th [style.display]="getConfigurazione().Rea" mat-header-cell *matHeaderCellDef> Rea
            <img src="./assets/images/sort.png" (click)="manageClick('Rea')"/>
          </th>
          <td [style.display]="getConfigurazione().Rea" mat-cell *matCellDef="let azienda"> {{azienda.Rea}} </td>
      </ng-container>

      <ng-container matColumnDef="Datarea">
          <th [style.display]="getConfigurazione().Datarea" mat-header-cell *matHeaderCellDef> Data Rea
            <img src="./assets/images/sort.png" (click)="manageClick('Datarea')"/>
          </th>
          <td [style.display]="getConfigurazione().Datarea" mat-cell *matCellDef="let azienda"> {{azienda.Datarea | date: 'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="Cameracommercio">
          <th [style.display]="getConfigurazione().Cameracommercio" mat-header-cell *matHeaderCellDef> Camera commercio
            <img src="./assets/images/sort.png" (click)="manageClick('Cameracommercio')"/>
          </th>
          <td [style.display]="getConfigurazione().Cameracommercio" mat-cell *matCellDef="let azienda"> {{azienda.Cameracommercio}} </td>
      </ng-container>

      <ng-container matColumnDef="Isactive">
        <th mat-header-cell *matHeaderCellDef [style.display]="getConfigurazione().Attivo"> Attivo
          <img src="./assets/images/sort.png" (click)="manageClick('Isactive')"/>
        </th>
        <td mat-cell *matCellDef="let azienda" [style.display]="getConfigurazione().Attivo">
          <mat-icon *ngIf="azienda.Isactive==true"  color="primary" (click)="toggleEnable(azienda)">check_circle</mat-icon>
          <mat-icon *ngIf="azienda.Isactive==false"  color="primary" (click)="toggleEnable(azienda)">check_circle_outline</mat-icon>
       </td>
      </ng-container>

      <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Modifica </th>
          <td mat-cell *matCellDef="let azienda">
            <mat-icon color="primary" (click)="editAzienda(azienda)">create</mat-icon>
          </td>
      </ng-container>

      <ng-container matColumnDef="customdata">
          <th [style.display]="getConfigurazione().customdata" mat-header-cell *matHeaderCellDef> Altro... </th>
          <td [style.display]="getConfigurazione().customdata" mat-cell *matCellDef="let azienda">
            <mat-icon color="primary" (click)="customdataAzienda(azienda)">view_headline</mat-icon>
          </td>
      </ng-container>
<!--
      <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Elimina </th>
          <td mat-cell *matCellDef="let user"><button class="btn btn-danger" (click)="deleteUser(user)">Elimina</button> </td>
      </ng-container>
-->


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
      <td>
        <button mat-raised-button  color="primary" (click)="newAzienda()">Nuova azienda</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
